import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-currency',
  templateUrl: './app-input-currency.component.html',
  styleUrls: ['./app-input-currency.component.scss']
})
export class AppInputCurrencyComponent {

  @Input() value: string = "";
  @ViewChild('inputView', { static: true }) inputView: ElementRef;
  @Input() label: string = "--";
  @Input() placeholder: string = "";
  @Input() icon: AppInputIcons;
  @Input() formControl: FormControl;
  @Input() showErrorLabel: boolean = true;
  @Input() customMessageError: string;
  
  @Input() thousands: string = ".";
  @Input() decimal: string = ",";
  @Input() precision: string = "2"; 
  @Input() prefix: string = ""; 
  @Input() suffix: string = ""; 
  @Input() align: string = "left"; 
  @Input() allowNegative: string = "false"; 

  @Input() max: number; 

  @Output() onChange = new EventEmitter<string>();
  @Output() onFocus = new EventEmitter<string>();
  @Output() onBlur = new EventEmitter<string>(); // (blur)="utilForm1.cpfValidate($event.target.value)"

  clearInputText() {
    this.inputView.nativeElement.value = "";
  }

  onChangeEvent(value): void {
    this.onChange.emit(value);
  }

  onBlurEvent(): void {
    this.onBlur.emit(this.value);
  }

  onFocusEvent() {
    this.onFocus.emit(this.value);
  }

  get isInvalid() {
    return (this.formControl && this.formControl.errors && (this.formControl.dirty || this.formControl.touched));
  }

  static getHtmlElement(element: string) {
    return document.querySelector<HTMLElement>(element)!;
  }

}

export enum AppInputIcons {
  search = "icon-search",
  calendar = "icon-calendario"
}